module.exports = __webpack_public_path__ + "static/blog_comprehensive_AI_design_tool-724aac5bea0c5c0225c69b395f3d9666.png";